// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"44aaaafb","453":"825386d9","457":"7c5a3420","851":"59466e1d"}[chunkId] + ".chunk.js";
};